import React, { useState, useEffect } from 'react';

const COOKIE_KEY = 'coachdesk365_cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(COOKIE_KEY)) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_KEY, 'accepted');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      background: '#2c2419',
      color: '#e8e0d4',
      padding: '16px 24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 20,
      zIndex: 9999,
      fontSize: '0.85rem',
      boxShadow: '0 -2px 12px rgba(0,0,0,0.15)',
    }}>
      <span>
        Diese Website verwendet ausschließlich technisch notwendige Cookies.{' '}
        <a href="/datenschutz" style={{ color: '#d4c5a9', textDecoration: 'underline' }}>
          Mehr erfahren
        </a>
      </span>
      <button
        onClick={handleAccept}
        style={{
          background: 'var(--primary-dark, #5D4E37)',
          color: '#fff',
          border: '1px solid var(--primary, #8B7355)',
          borderRadius: 6,
          padding: '8px 20px',
          cursor: 'pointer',
          fontWeight: 600,
          fontSize: '0.85rem',
          whiteSpace: 'nowrap',
        }}
      >
        Verstanden
      </button>
    </div>
  );
}
